import { PublicationSheet } from '@livv/models';
import { Translate } from 'next-translate';
import { META_DESCRIPTION_MAX_LENGTH } from '@utils/consts/seo';

const getSheetFirstParagraph = (sheet: PublicationSheet): string | undefined =>
    sheet?.content?.blocks && sheet.content.blocks.length > 0
        ? sheet?.content?.blocks[0].text
        : undefined;

const getPublicationMetaDescription = (
    bookTheme: string,
    bookTitle: string,
    t: Translate,
    sheet?: PublicationSheet,
): string => {
    if (sheet) {
        const firstParagraph = getSheetFirstParagraph(sheet);
        if (!firstParagraph) {
            return '';
        }

        return firstParagraph.trim().slice(0, META_DESCRIPTION_MAX_LENGTH);
    }

    const translatedTheme = t(`theme.${bookTheme}`);

    return `${t('meta.descriptionFirstPage', {
        theme: translatedTheme,
        title: bookTitle,
    })}`;
};

export { getPublicationMetaDescription };
